var map = {
	"./bash": 1757,
	"./java": 1758,
	"./json": 1759,
	"./julia": 1760,
	"./python": 1761,
	"./r": 1762,
	"./rust": 1763,
	"./scala": 1764,
	"./shell": 1765,
	"./sql": 1766,
	"./xml": 1767,
	"./yaml": 1768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1756;